import React, { useEffect, useCallback } from "react";

import FullPageLoader from "../FullPageLoader";

import * as loginApi from "js/api/loginApi";
import * as authApi from "js/api/authApi";
import { LoginDelegatedRequest } from "js/api/authApi";
import { useUserSessionStore } from "stores/v2/userSessionStore";
import { useLocation, useNavigate } from "react-router-dom";
const LoginMicrosoftCallback: React.FC = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const handleLoginFailure = useCallback(
		(error: unknown): void => {
			const apiError = error as authApi.ApiError<authApi.LoginMethodError> | authApi.ApiError<authApi.ServerError>;
			useUserSessionStore.getState().handleAuthenticationFailure(apiError);

			if (apiError.respJson && "provider" in apiError.respJson) {
				navigate("/login", { state: { provider: apiError.respJson.provider } });
			} else {
				navigate("/login", { state: { error: "Microsoft" } });
			}
		},
		[navigate]
	);

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		const loginRequest: LoginDelegatedRequest = {
			code: searchParams.get("code") || "",
			deviceid: searchParams.get("state") || "",
		};

		authApi
			.loginDelegated(loginApi.LoginProvider.MICROSOFT, loginRequest)
			.then((res) => {
				useUserSessionStore
					.getState()
					.handleAuthenticationSuccess(res)
					.then(() => navigate("/"))
					.catch(handleLoginFailure);
			})
			.catch(handleLoginFailure);
	}, [navigate, handleLoginFailure, location]);

	return <FullPageLoader message="Logging in with Microsoft" />;
};

export default LoginMicrosoftCallback;
